define('models/StoreLocatorModel',['underscore','jquery','site_vars','ObjectModel',
    'string',
    'UrlFactory',
    'app',
    'models/StoreLocationModel',
    'models/CityCollection',
    'models/StateCollection'
],function (_,$,site_vars, ObjectModel,
    S,
    UrlFactory,
    app,
    StoreLocationModel,
    CityCollection,
    StateCollection
) {


    var singleton,
        cities = new CityCollection(),
        states = new StateCollection(),
        _BUNDLE_COLLECTIONS_ = _([
            cities, states,
        ]);

    var _STORE_TYPES_ = _([
        {type:'store',label:'Boutique'},
        {type:'corner',label:'Corner'},
        {type:'travel-retail',label:'Travel retail'}
    ]), _STORE_TYPES_COUNT_;

    function getStoreTypes(){
        return _STORE_TYPES_;
    }

    function getStoreTypesCounts(){
        var storeTypesCount = _STORE_TYPES_COUNT_;
        if(!storeTypesCount) {
            var stores = app.getStores();
            storeTypesCount = _(getStoreTypes().map(function (o, index) {

                var label = o.label,
                    count = stores.getCount(index);

                label = count > 1 ? label + 's' : label;

                return _.defaults({
                    label: app.t(label, 'Stores'),
                    val: count
                }, o);
            }))
        }
        return storeTypesCount;
    }

    var StoreLocatorPrototype = {

        route:'apiStoreLocatorBundle',
        name:'StoreLocatorModel',

        defaults: {
            dataReady: false,
            valid: true,
            type: 'root', // current view type
            id: '', // current view ressource id
            searchPending:false,
            inputSearch:'',
        },

        initialize:function(){

            singleton = this;
            ObjectModel.prototype.initialize.apply(this,arguments);

            function Setup(){
                _BUNDLE_COLLECTIONS_.each(function(collection){
                    collection.reset(singleton.get(collection.bundleId));
                });
                singleton.set('dataReady',true);
                singleton.trigger('dataReady');
            }

            app.getStores().syncExceptionnalClosure(AfterSyncExceptionnalClosure)

            // après avoir chargé les fermetures exceptionnelles
            function AfterSyncExceptionnalClosure(){
                singleton.once('sync',Setup);
                singleton.fetch();
            }

        },

        getCities:function() {
            return cities;
        },
        getCity:function(cityId) {
            return cities.getById(cityId);
        },
        getCityByLinkSEO: function(link_rewrite) {
            return cities.getByLinkSEO(link_rewrite);
        },
        getState:function(id) {
            return states.getById(id);
        },
        getStates:function() {
            return states;
        },
        getStateByLinkSEO: function(link_rewrite) {
            return states.getByLinkSEO(link_rewrite);
        },
        getStoreTypes:getStoreTypes,
        getStoreTypesCounts:getStoreTypesCounts,
        isSingle:function(){
            return this.get('subpage') === 'single';
        },
        preset:function(options){
            this.set(_(options).defaults({
                id_store:false, // single
                url_rewrite:false, // single
                search_path:false, // listing
                microtemplateStart:false
            }));
        },
        resetPageData:function(){
            // cette fonction applique une nouvelle route
            // et donc prépare les données à afficher.
            //
            var datas = {},
                _STORES_BASE_URL_ = app.c('_STORES_BASE_URL_'),
                _STORE_BASE_URL_ = app.c('_STORE_BASE_URL_'),
                isSingle = singleton.isSingle(),
                type,
                storeLocationOptions = {},
                storeLocation,
                breadcrumbRootItem = {
                    url:UrlFactory.getUrl('stores'),
                    name:app.t('Tous nos shops','Stores'),
                },
                defaultTitle = app.c('_STORE_BASE_SEO_TITLE_', 'Nos Restaurants Japonais & Sushi'),
                meta_title = app.c('_STORE_LOCATOR_TITLE_SEO_', 'Nos Restaurants Japonais & Sushi'),
                defaultDatas = {
                    // commun à toutes les pages
                    title:defaultTitle,
                    meta_title:meta_title,
                    meta_description:'',
                    subtitle:app.t('Trouver une boutique SushiShop','Stores'),
                    description_seo:'',
                    footer_seo:'',
                    content_description:'',
                    content_footer:'',
                    search:'',
                    faq:_([]),
                    breadcrumb:_([breadcrumbRootItem]),
                    // seulement pour la page boutique
                    store:false,
                    // seuelement pour la page recherche
                    stores:false,
                    storeTypesCounts:getStoreTypesCounts(),
                    internal_mesh:false,
                    mapOpened: false,
                },
                object = null,
                store;
            if(isSingle){
                // page boutique
                type = 'store';

                // on obtient la boutique à partir
                // de l'id_store (chargement initial)
                // ou du link_rewrite (microtemplating)
                object = store = app.getStore(singleton.get('id_store'))
                    || app.getStores().findByUrlRewrite(singleton.get('url_rewrite'));
                if(store){
                    store.setDeliveryAreas();
                    datas = {
                        title: store.getFullName(),
                        meta_title: store.get('titre_seo'),
                        meta_description: store.get('description_seo'),
                        subtitle: store.formatAddress(),
                        store:store,
                        faq:_(store.get('faq') || []),
                        breadcrumb:_(store.get('breadcrumb'))
                    }
                    storeLocationOptions.shop = store;
                }
            }else
                {
                // page recherche
                var search_path = singleton.get('search_path'),
                    label = null,
                    fullName = '';
                if(!search_path){
                    // racine du store loc
                    type = 'root';
                    var states = singleton.getStates();
                    var internal_mesh = [];
                    var _STORELOC_STATE_PREFIX_ = app.c('_STORELOC_STATE_PREFIX_');
                    states.each(function(s){
                        var m = {};
                        m.url = _STORES_BASE_URL_+'/'+_STORELOC_STATE_PREFIX_+'/'+s.get("link_rewrite");
                        m.label = s.get("name")
                        internal_mesh.push(m);
                    });

                    datas = {
                        internal_mesh : {
                            states : {
                                title: app.t('Régions où nous sommes présents','Stores'),
                                items:_(internal_mesh)
                            }
                        }
                    }

                }else{
                    // on décompose le path de recherche en 2 parties, prefix et term
                    var parts = /(([\w\d\-]+)\/)?([\w\d\-\.\_]+)/ig.exec(search_path),
                        prefix = parts ? parts[2] : false,
                        term = parts ? parts[3] : false;
                    if (prefix === app.c("_STORELOC_STORE_PREFIX_", 's')
                        && !!(object = app.getStores().findByUrlRewrite(term))){
                        type = 'shop';
                        defaultDatas.store = object;
                        object.setDeliveryAreas();
                    }else if(prefix === app.c("_STORELOC_STATE_PREFIX_", 'r')
                        && !!(object = singleton.getStateByLinkSEO(term))){
                        type = 'state'
                    }else if(prefix === app.c("_STORELOC_BOUNDS_PREFIX_", 'bounds')
                        && !!(object = /(-?\d*\.?\d+)_(-?\d*\.?\d+)_(-?\d*\.?\d+)_(-?\d*\.?\d+)$/g.exec(term))){
                        type = 'bounds'
                        object = [
                            parseFloat(object[4]),
                            parseFloat(object[3]),
                            parseFloat(object[2]),
                            parseFloat(object[1])
                        ];
                        label = app.t('Dans la zone','StoreLocSeo');
                        datas = {
                            mapOpened: true,
                            breadcrumb:_([breadcrumbRootItem,{name:label}])
                        }
                        storeLocationOptions.bounds = object;
                    }else if(prefix === app.c("_STORELOC_POSITION_PREFIX_", 'pos')
                        && !!(object = /(-?\d*\.?\d+)_(-?\d*\.?\d+)$/.exec(term))){
                        type = 'position';
                        object = [
                            parseFloat(object[2]),
                            parseFloat(object[1])
                        ];
                        label = app.t('À proximité','StoreLocSeo');
                        datas = {
                            mapOpened: true,
                            breadcrumb:_([breadcrumbRootItem,{name:label}])
                        }
                        storeLocationOptions.position = object;
                    }else if(prefix && !!(object = app.getPostcodeByLinkSEO(term))){
                        type = 'postcode'
                    }else if(term && !!(object = singleton.getCityByLinkSEO(term))){
                        type = 'city'
                    }else{
                        type = 'empty'
                    }
                    storeLocationOptions[type] = object;

                    if(_.contains(['city', 'shop', 'postcode', 'state'],type)){

                        fullName = object.get('h1_seo')  || '' ;

                       label = object.get('name') || '';
                       if (fullName == "")
                       {
                           fullName = label;
                       }
                        meta_title = object.get('titre_seo');
                        if(type==='shop'){
                            fullName = object.getFullName();
                        }
                        var description_seo = object.get('description_seo') || null,
                            footer_seo = object.get('footer_seo') || null,
                            content_description = description_seo,
                            content_footer = footer_seo;
                            ;
                        if(!!footer_seo){
                            content_description = footer_seo;
                            content_footer = '';
                        }
                        internal_mesh = object.get('internal_mesh');
                        var internal_mesh_cities = [],
                            internal_mesh_arrondissements = [];
                        _(internal_mesh).each(function(link){
                            var linkType = link.type, url = link.link_rewrite, label = link.name;
                            if(linkType==='store'){
                                url = UrlFactory.getUrl('store',{store_rewrite:link.store_link});
                            }else if(linkType==='arrondissement'){
                                url = UrlFactory.getUrl('storeLocatorPostcode',{city:link.link_city,postcode:link.link_rewrite});
                            }else{
                                url = UrlFactory.getUrl('storeLocatorSearch',{search:url});
                            }
                            link.url = url;
                            link.label = label;
                            if(linkType==='arrondissement'){
                                internal_mesh_arrondissements.push(link);
                            }else{
                                internal_mesh_cities.push(link);
                            }
                        });
                        datas = {
                            breadcrumb : _(object.get('breadcrumb')),
                            faq : _(object.get('faq')),
                            // search : breadcrumb.last().name ,
                            description_seo : description_seo,
                            footer_seo : footer_seo,
                            content_description : content_description,
                            content_footer : content_footer,
                            meta_title : meta_title,
                            title : fullName,
                            internal_mesh : {
                                cities:{
                                    title:app.t('Villes où nous sommes présents','Stores'),
                                    items:_(internal_mesh_cities)
                                },
                                arrondissements:{
                                    title:app.t('Arrondissements où nous sommes présents','Stores'),
                                    items:_(internal_mesh_arrondissements)
                                },
                            },
                        }
                        if(type==='state' || type==='city'){
                            datas.subtitle  = app.t('Trouver votre shop le plus proche','Stores');

                        }
                    }
                }
                datas.label = label || '';
            }
            storeLocationOptions.type = type;
            singleton.set({
                object:object,
                type:type,
                storeLocation : new StoreLocationModel(storeLocationOptions),
                datas:_.defaults(datas,defaultDatas)
            });
        },
        getStore:function(){
            return this.getTemplateDatas().store;
        },
        getTemplateDatas:function(){
            var datas = this.get('datas');
            if (datas)
            datas.type = this.getTemplateType();
            return datas;
        },
        getTemplateType:function(){
            return this.get('type');
        },
        getFilteredResults:function(filters, stores) {
            var listStores = stores.length ? stores : app.getStores(),
                hasFilter = filters.type >= 0 || filters.benefit.length > 0;
            if (!hasFilter) {
                return stores;
            }

            var result = []
            listStores.each(function(store,i){
                var typeVisible = filters.type >= 0
                ? (filters.type == store.get('type_shop'))
                : true

                var benefitVisible = true;
                _(filters.benefit).each(function(benefit) {
                    var storeBenefit = store.get('benefit')
                    benefitVisible = (
                        benefitVisible
                        && storeBenefit
                        && (storeBenefit.primary.includes(benefit.toString()) || storeBenefit.secondary.includes(benefit.toString()))
                    )
                })
                if (typeVisible && benefitVisible) {
                    result.push(store)
                }
            });
            return _(result)
        }
    };

    var StoreLocator = ObjectModel.extend(StoreLocatorPrototype);

    StoreLocator.getInstance = function(){
          if(!singleton){
              singleton = new StoreLocator();
          }
          return singleton;
    };

    return StoreLocator;

});
